export default __webpack_public_path__ + "static/media/GenomeBioExpo_2022_video.beb142c7.mp4";